<template>
  <b-container fluid>
    <b-row class="mb-2">
      <b-col class="px-sm-3 px-0">
        <h1>Items</h1>
      </b-col>
      <b-col v-if="brandAdmin" class="text-right px-sm-3 px-0">
        <b-button variant="primary" @click="$router.push('items/create')"
          >Add Item</b-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col class="px-sm-3 px-0">
        <b-overlay :show="loading" no-wrap fixed />
        <b-form inline class="mb-2" @submit.prevent="applyFilters">
          <b-form-input
            v-model="queryFilters.search"
            placeholder="Search by name, id or description"
            title="Search by name, id or description"
            class="mr-2 mb-2 single-input"
          />
          <custom-search-field
            v-model="queryFilters.brand"
            class="mr-2 mb-2 single-input"
            :placeholder="'Filter by brand'"
            :path-to-search="'brands'"
            :query-params="{
              status: 'active,inactive',
            }"
          />
          <b-form-group class="custom-search-input mr-2 mb-2">
            <multiselect
              v-model="queryFilters.status"
              select-label=""
              open-direction="bottom"
              :options="statusOptions"
              track-by="value"
              deselect-label="remove"
              :searchable="false"
              :close-on-select="true"
              :show-no-results="false"
              :hide-selected="false"
              label="text"
              placeholder="Filter by status"
              class="single-input"
            />
          </b-form-group>
          <b-button type="submit" variant="primary" class="mb-2"
            >Filter</b-button
          >
        </b-form>
      </b-col>
    </b-row>
    <b-row class="overflow-auto">
      <b-col class="px-sm-3 px-0">
        <b-table
          hover
          no-local-sorting
          small
          :fields="fields"
          :items="data"
          :busy="busy"
          @sort-changed="onSortingChanged"
          @row-clicked="onRowClicked"
        >
          <template #cell(name)="row">
            <router-link :to="`/items/${row.item.id}`">
              {{ row.item.name }}
            </router-link>
          </template>
          <template #cell(price)="row">
            {{ (row.item.price / 100) | currency }}
          </template>
          <template #cell(status)="row">
            {{ row.item.status | capitalize }}
          </template>
          <template #cell(brand)="row">
            <template v-if="row.item.brand">
              {{ row.item.brand.name }}
            </template>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <pagination-handler v-if="data.length" :query-data="queryFilters" />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import tableMixin from '../../mixins/TableMixin';
import ResourceAPI from '../../services/ResourceAPI';

export default {
  name: 'Items',
  mixins: [tableMixin],
  data() {
    return {
      statusOptions: [
        {
          value: 'active',
          text: 'Active',
        },
        {
          value: 'inactive',
          text: 'Inactive',
        },
      ],
      fields: [
        {
          key: 'name',
          label: 'Item',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'price',
          label: 'Price',
          sortable: true,
        },
        {
          key: 'brand',
          label: 'Brand',
          sortable: true,
        },
        {
          key: 'import_key',
          label: 'Import Key',
          sortable: true,
        },
      ],
      data: [],
      loading: false,
      exportAlert: false,
      rowRouteName: 'item',
    };
  },
  computed: {
    ...mapGetters('session', [
      'brandAdmin',
      'brandCount',
      'hubCount',
      'kitchenCount',
    ]),
  },
  methods: {
    loadResults() {
      this.setRequestData();

      // Format search params for query
      const searchParams = { ...this.queryFilters };
      searchParams.status = searchParams.status
        ? searchParams.status.value
        : 'active,inactive';
      searchParams.fulfillmentCenter = searchParams.kitchen
        ? searchParams.kitchen.id
        : null;
      searchParams.brand = searchParams.brand ? searchParams.brand.id : null;
      searchParams.menu = searchParams.menu ? searchParams.menu.id : null;
      searchParams.with = 'brand';
      searchParams.brandStatus = 'active,inactive';

      return ResourceAPI.getRecords('items', searchParams)
        .then((data) => {
          this.setResponseData(data);
        })
        .catch((error) => alert(error));
    },
  },
};
</script>
